export const INTERRUPTION_CREATE_FORM_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  pt: 0.5,
  mb: 2,
  '.floating-label-input': { mb: '0px!important' },
  '.floating-label-baseInput': { mb: '0px!important' },
  '.MuiFormControl-root': { mb: '0px!important' },
} as const;
